/**
 * Main Title
 * Common dashboard root level title
 */
import { Typography } from '@mui/material';
import React from 'react';

import { useIsMobile } from '@hooks/useIsMobile';

import { FontWeight } from '../../theme/typography';

const MainTitle: React.FC<{ title: React.ReactNode; subtitle?: string }> = ({
  title,
}) => {
  const isMobile = useIsMobile();

  return (
    <Typography
      color="primary.main"
      data-testid="main-title"
      pl={2}
      py={2}
      sx={{
        fontSize: isMobile ? 30 : 40,
        fontWeight: isMobile ? FontWeight.Regular : FontWeight.Medium,
        textTransform: 'capitalize',
      }}
    >
      {title}
    </Typography>
  );
};

export default MainTitle;
